import colors from 'constants/colors';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 81px;
  cursor: pointer;

  .messageBody {
    font-size: 12px;
    padding: 13px 5px;
    width: 100%;
    min-width: 224px;
    position: relative;

    &:before {
      content: '';
      background-color: ${(props) => props.isRead? colors.grey: colors.lightGreen};
      position: absolute;
      width: 4px;
      top: 10px;
      bottom: 10px;
      border-radius: 50px;
    }

    .messageInfo {
      margin-left: 10px;
      font-weight: 600;
      white-space: nowrap;
      /* overflow: hidden;
      text-overflow: ellipsis; */
      
      .originator {
        margin-right: 10px;
        color: ${(props) => props.isRead? colors.grey: colors.white};
      }

      .roomNumber {
        color: ${(props) => props.isRead? colors.grey: colors.yellow};
      }
    }

    .dateTime {
      margin-left: 10px;
      color: ${(props) => props.isRead? colors.grey: colors.silver};
    }

    .description {
      margin-left: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: ${(props) => props.isRead? colors.grey: colors.white};
    }
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {
    ${({ mobile }) => (mobile? `
      height: 110px;
      .messageBody {
        font-size: 15px;
        line-height: 2;
      }
    `: null
    )};
  }

  @media only screen and (max-width: 767px) {
    ${({ mobile }) => (mobile? `
      height: 89px;
      .messageBody {
        font-size: 13px;
      }
    `: null
    )};
  }
`;
